module.exports = __webpack_public_path__ + "static/img/icon.42ddd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/icon.png
// module id = bGtA
// module chunks = 44